module.exports = __webpack_public_path__ + "static/media/aws.b7f09ee2.svg";